const data = [
    {
        "id": 1,
        "img_url": "https://assets.change.org/photos/2/xo/ys/RdXOysAKqGNAKvM-800x450-noPad.jpg?1614364073",
        "petition_to": "Petition to Twin Rivers Unified School District, grant union high school",
        "title": "TRUSD Must Condemn Anti-Asian and Racist Behavior",
        "url": "https://www.change.org/p/twin-rivers-unified-school-district-trusd-must-condemn-anti-asian-and-racist-behavior"
    },
    {
        "id": 2,
        "img_url": "https://assets.change.org/photos/2/xo/ys/RdXOysAKqGNAKvM-800x450-noPad.jpg?1614364073",
        "petition_to": "Petition to UK Parliament, United Nations, Southampton City Council",
        "title": "Stop Violence & Abuse Against Chinese & Asian People",
        "url": "https://www.change.org/p/uk-parliament-stop-violence-abuse-against-chinese-asian-people"
    },
    {
        "id": 3,
        "img_url": "https://assets.change.org/photos/2/xo/ys/RdXOysAKqGNAKvM-800x450-noPad.jpg?1614364073",
        "petition_to": "Petition to Marian Pham",
        "title": "Stop Asian Hate",
        "url": "https://www.change.org/p/marian-pham-stop-asian-hate"
    },
    {
        "id": 4,
        "img_url": "https://assets.change.org/photos/2/xo/ys/RdXOysAKqGNAKvM-800x450-noPad.jpg?1614364073",
        "petition_to": "Petition to BBC, UK Parliament, The Guardian",
        "title": "Stop depicting East  & South East Asians in Coronavirus related media",
        "url": "https://www.change.org/p/stop-depicting-east-south-east-asians-in-coronavirus-related-media"
    },
    {
        "id": 5,
        "img_url": "https://assets.change.org/photos/2/xo/ys/RdXOysAKqGNAKvM-800x450-noPad.jpg?1614364073",
        "petition_to": "Petition to Scarsdale Community",
        "title": "Scarsdale: STOP Anti-Asian Violence",
        "url": "https://www.change.org/p/scarsdale-community-stop-no-more-anti-asian-violence"
    },
    {
        "id": 6,
        "img_url": "https://assets.change.org/photos/2/xo/ys/RdXOysAKqGNAKvM-800x450-noPad.jpg?1614364073",
        "petition_to": "Petition to President Donald J. Trump",
        "title": "President Trump, your \"kung-flu\" joke was offensive, pathetic -- and racist.",
        "url": "https://www.change.org/p/president-donald-j-trump-president-trump-your-kung-flu-joke-was-offensive-pathetic-and-racist-dae01d48-0c94-4899-ab02-0cc767a3b2b6"
    },
    {
        "id": 7,
        "img_url": "https://assets.change.org/photos/2/xo/ys/RdXOysAKqGNAKvM-800x450-noPad.jpg?1614364073",
        "petition_to": "Petition to DHC , Yoshiaki Yoshida, DHC Corp, Target, Amazon.com, Facebook, Mark Zuckerberg, los angeles times, Time Magazine, The new yorker, New York Post, New York Times, Jezebel , splinter , Jeff Bezos",
        "title": "STOP DHC: FIGHT AGAINST SEXISM, RACISM, ANTI SEMITISM.",
        "url": "https://www.change.org/p/dhc-cleansing-oil-that-fuels-hate-dhc-is-the-enemy-of-humanity-fight-sexism-racism-anti-semitism-and-historical-revisionism"
    },
    {
        "id": 8,
        "img_url": "https://assets.change.org/photos/2/xo/ys/RdXOysAKqGNAKvM-800x450-noPad.jpg?1614364073",
        "petition_to": "Petition to The Sun, Telegraph , Daily Mail, Public Health England, Independent Press Standards Organisation (IPSO)",
        "title": "Pakistan didn't cause the pandemic - racist British reports will increase hate crime.",
        "url": "https://www.change.org/p/the-sun-pakistan-didn-t-cause-the-pandemic-racist-british-reports-will-increase-hate-crime"
    },
    {
        "id": 9,
        "img_url": "https://assets.change.org/photos/2/xo/ys/RdXOysAKqGNAKvM-800x450-noPad.jpg?1614364073",
        "petition_to": "Petition to President of the United States",
        "title": "Help stop the Asian hate crimes!",
        "url": "https://www.change.org/p/president-of-the-united-states-help-stop-the-asian-hate-crimes"
    },
    {
        "id": 10,
        "img_url": "https://assets.change.org/photos/2/xo/ys/RdXOysAKqGNAKvM-800x450-noPad.jpg?1614364073",
        "petition_to": "Petition to Everyone",
        "title": "Help Stop Asian Hate",
        "url": "https://www.change.org/p/everyone-help-stop-asian-hate"
    }
    
];

export default data;